(function() {
  function initBrevoSignup() {
    document.querySelectorAll('.custom-brevo-signup[data-brevo-key]:not([data-brevo-init])').forEach(function(block) {
      block.setAttribute('data-brevo-init', 'true');

      var apiKey = block.getAttribute('data-brevo-key');
      var listId = parseInt(block.getAttribute('data-brevo-list') || '3', 10);
      var btnText = block.getAttribute('data-brevo-btn') || "Je m'abonne";
      var btn = block.querySelector('.custom-brevo-signup__button');
      var input = block.querySelector('.custom-brevo-signup__input');
      var successEl = block.querySelector('.custom-brevo-signup__message--success');
      var errorEl = block.querySelector('.custom-brevo-signup__message--error');

      if (!btn || !input) return;

      btn.addEventListener('click', function() {
        var email = input.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          input.focus();
          return;
        }

        btn.disabled = true;
        btn.textContent = '...';
        successEl.style.display = 'none';
        errorEl.style.display = 'none';

        fetch('https://api.brevo.com/v3/contacts', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'api-key': apiKey
          },
          body: JSON.stringify({
            email: email,
            listIds: [listId],
            updateEnabled: true
          })
        })
        .then(function(resp) {
          if (resp.ok || resp.status === 204) {
            successEl.style.display = 'block';
            input.value = '';
            return;
          }
          return resp.json().then(function(data) {
            if (data.code === 'duplicate_parameter') {
              successEl.style.display = 'block';
              input.value = '';
            } else {
              throw new Error(data.message || 'Erreur');
            }
          });
        })
        .catch(function() {
          errorEl.style.display = 'block';
        })
        .finally(function() {
          btn.disabled = false;
          btn.textContent = btnText;
        });
      });

      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') btn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrevoSignup);
  } else {
    initBrevoSignup();
  }

  new MutationObserver(initBrevoSignup).observe(document.body, { childList: true, subtree: true });
})();